document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.featured-collection-carousel');

    carousels.forEach((carousel) => {
        const viewport = carousel.querySelector('.featured-collection-carousel__viewport');
        if (!viewport) return;

        const prevButton = carousel.querySelector('.featured-collection-carousel__prev');
        const nextButton = carousel.querySelector('.featured-collection-carousel__next');

        const getScrollAmount = () => {
            const firstSlide = viewport.firstElementChild;
            if (!firstSlide) return viewport.clientWidth;
            const styles = window.getComputedStyle(viewport);
            const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
            return firstSlide.getBoundingClientRect().width + gap;
        };

        const updateButtonStates = () => {
            const maxScroll = viewport.scrollWidth - viewport.clientWidth;
            if (prevButton) prevButton.disabled = viewport.scrollLeft <= 0;
            if (nextButton) nextButton.disabled = viewport.scrollLeft >= maxScroll - 1;
        };

        prevButton?.addEventListener('click', () => {
            viewport.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });

        nextButton?.addEventListener('click', () => {
            viewport.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });

        viewport.addEventListener('scroll', updateButtonStates, { passive: true });
        window.addEventListener('resize', updateButtonStates);

        updateButtonStates();
    });
});
